import { create } from 'zustand';
import { authApi } from '../services/authApi.js';
import { setAccessToken } from '../services/api.js';

// Module-level singleflight: React StrictMode mounts components twice in
// development, which would otherwise fire two parallel /auth/refresh requests
// and rotate the refresh-token cookie twice on every page load.
let initPromise = null;
let logoutListenerAttached = false;

export const useAuthStore = create((set, get) => ({
  user: null,
  isLoading: true,

  init: async () => {
    if (initPromise) return initPromise;
    initPromise = (async () => {
      set({ isLoading: true });
      try {
        // Try to refresh token; if successful, fetch user
        const { accessToken } = await authApi.refresh();
        setAccessToken(accessToken);
        const user = await authApi.me();
        set({ user, isLoading: false });
      } catch {
        setAccessToken(null);
        set({ user: null, isLoading: false });
      }
      if (!logoutListenerAttached) {
        logoutListenerAttached = true;
        window.addEventListener('auth:logout', () => {
          setAccessToken(null);
          set({ user: null });
        });
      }
    })();
    return initPromise;
  },

  login: async (email, password) => {
    const result = await authApi.login({ email, password });
    setAccessToken(result.accessToken);
    set({ user: result.user });
    return result.user;
  },

  register: async (data) => {
    const result = await authApi.register(data);
    setAccessToken(result.accessToken);
    set({ user: result.user });
    return result.user;
  },

  logout: async () => {
    try {
      await authApi.logout();
    } catch {
      /* ignore */
    }
    setAccessToken(null);
    set({ user: null });
  },

  refreshUser: async () => {
    const user = await authApi.me();
    set({ user });
    return user;
  }
}));
